{
  "frameCount": 64,
  "columns": 8,
  "frameSize": {
    "1x": 96,
    "2x": 192
  },
  "headingDegreesPerFrame": 5.625,
  "frame0Heading": "north-up",
  "rotation": "clockwise"
}
